var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.17,
    cx: 11.75,
    cy: 11,
    r: 9,
    fill: "url(#paint0_linear_1107_233704)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "url(#paint1_linear_1107_233704)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7826 16.0769V17C11.8008 17 12.6095 16.6063 13.2273 16.0769H10.7826Z",
    fill: "url(#paint2_linear_1107_233704)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43494 11.4615V12.3846C6.43494 13.5385 7.30449 13.7692 7.30449 13.7692C7.30449 13.7692 8.17405 16.5385 10.7827 16.5385",
    stroke: "url(#paint3_linear_1107_233704)",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5651 11.9231H14.2608C14.2608 9.04309 12.9564 7.76924 12.9564 7.76924C11.6521 11 7.30433 8.69232 7.30433 11.9231H6C6 11.9231 6 11.8686 6 10.0769C6 6.84616 8.60867 5 10.7826 5C12.5217 5 12.9564 5.92308 12.9564 5.92308C14.6956 5.92308 15.5651 8.23078 15.5651 10.0769V11.9231Z",
    fill: "url(#paint4_linear_1107_233704)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.7693C10.9235 13.7693 10.6418 13.7693 10.5653 13.7693C10.2053 13.7693 9.91309 14.0794 9.91309 14.4616C9.91309 14.8438 10.2053 15.1539 10.5653 15.1539C10.6418 15.1539 10.9235 15.1539 11 15.1539C11.36 15.1539 11.6522 14.8438 11.6522 14.4616C11.6522 14.0794 11.36 13.7693 11 13.7693Z",
    fill: "url(#paint5_linear_1107_233704)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2175 14.6923H13.3914C14.3518 14.6923 15.1305 13.8657 15.1305 12.8462V11.4615",
    stroke: "url(#paint6_linear_1107_233704)",
    strokeWidth: 0.833333,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1305 13.3077H14.261V11H15.1305C15.611 11 16.0001 11.4131 16.0001 11.9231V12.3846C16.0001 12.8946 15.611 13.3077 15.1305 13.3077Z",
    fill: "url(#paint7_linear_1107_233704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1107_233704",
    x1: 11.606,
    y1: 1.208,
    x2: 11.894,
    y2: 20.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1107_233704",
    x1: 21.2712,
    y1: -2.92858,
    x2: 5.01229,
    y2: -2.18077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1107_233704",
    x1: 13.2605,
    y1: 15.8956,
    x2: 11.298,
    y2: 16.1347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1107_233704",
    x1: 10.8417,
    y1: 10.4643,
    x2: 7.30517,
    y2: 10.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1107_233704",
    x1: 15.6948,
    y1: 3.6401,
    x2: 7.93379,
    y2: 4.13329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1107_233704",
    x1: 11.6758,
    y1: 13.4973,
    x2: 10.2637,
    y2: 13.5789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1107_233704",
    x1: 15.1836,
    y1: 10.8269,
    x2: 12.0057,
    y2: 11.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1107_233704",
    x1: 16.0237,
    y1: 10.5467,
    x2: 14.6086,
    y2: 10.5958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c744aeb34cbe7b48f424ac3a31b437cf.svg";
export { ForwardRef as ReactComponent };